import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://trainplan-mongo-api.reges-services.se'
})

export default instance
